import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiPartnerService } from '@app/api/api-partner.service';

@Component({
  selector: 'app-list-storeshop',
  templateUrl: './list-storeshop.component.html',
  styleUrls: ['../listorder.component.css']
})
export class ListStoreshopComponent implements OnInit {

  constructor(
    public partnerService : ApiPartnerService,
    private route : ActivatedRoute,
    private router : Router
  ) {}

  showTable = false;
  showLoad  = false;
  listStore : any = {};

  //Pagination
  paging: any = {};	
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  meta = [];
  self = [];

  ngOnInit() {
    this.loadStart();
  }
  
  refreshPage() {
    this.showTable = false;
    this.showLoad = true;
    setTimeout(()=>{
      this.showLoad = false;
      this.showTable = true;
    }, 3000);
    this.ngOnInit();    
  }

  loadStart(){
    this.route.queryParams.subscribe(params => {
        console.log(params); // {order: "name"}

        //this.order = params.order;
        //console.log(this.order); // name

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
          this.msearch = params.search; 
          this.querySearch = true;
          this.showLoad = false;
        

          this.currentParams = params;
          this.queryParams = '?'+this.queryStr(params);
          this.loadStore(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadStore(this.queryParams);
        }
      });
  }

  loadStore(queryParams : any){
    return this.partnerService.GetListStoreshop(queryParams).subscribe((output: any) => {
        this.listStore = output.data;
        console.log(output);
        this.showTable = true;
        this.showLoad = false;
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }
  
  queryStr(options){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search(){
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.showLoad = true;
    this.loadStore(this.searchQueryParams);
  }

  onDelete(){
    
  }
}
